module.exports = __webpack_public_path__ + "static/media/Okex.318cdb14.svg";